import { render } from "./CaricamentoLetture.vue?vue&type=template&id=2f7043a5&scoped=true"
import script from "./CaricamentoLetture.vue?vue&type=script&lang=js"
export * from "./CaricamentoLetture.vue?vue&type=script&lang=js"

import "./CaricamentoLetture.vue?vue&type=style&index=0&id=2f7043a5&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7043a5"]])

export default __exports__